<template>
    <div :class="classes">
        <h4 class="title">
            {{ title }}
        </h4>
        <div v-for="category in rulesNotEmpty" :key="category.name" class="category">
            <h4>{{ category.name }}</h4>
            <ul>
                <li v-for="(rule, n) in category[type]" :key="n">
                    {{ rule }}
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'BriefRuleset',
    props: {
        type: {
            type: String,
            default: 'do',
            validator (value) {
                return ['do', 'dont'].includes(value);
            },
        },
        title: {
            type: String,
            default: '',
        },
        rules: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        classes () {
            return {
                ruleset: true,
                [this.type]: true,
            };
        },
        rulesNotEmpty () {
            return this.rules.filter((rule) => rule[this.type] && rule[this.type].length > 0);
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

.ruleset {
    @include card(20px);

    &.do {
        > .title {
            color: $green;
        }

        > .category {
            > ul {
                list-style-image: url('../../assets/img/do.svg');
            }
        }
    }

    &.dont {
        > .title {
            color: $red;
        }

        > .category {
            > ul {
                list-style-image: url('../../assets/img/dont.svg');
            }
        }
    }

    > .title {
        text-align: center;
    }

    > .category {
        > h4 {
            color: $grey-dark;
        }

        > ul {
            > li {
                padding-left: 20px;

                &:not(:last-of-type):not(:only-of-type) {
                    margin-bottom: 12px;
                }
            }
        }
    }
}
</style>
